module.exports = __webpack_public_path__ + "img/icon-point-wallet.2bdfb1d7.svg";